import { createContext } from 'react';
import { DEFAULT_META_CONTEXT } from './constants/defaultContext';

export const MetaContext = createContext(DEFAULT_META_CONTEXT);
